import { useEffect, useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import MenuItem from "@mui/material/MenuItem";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

// Material Dashboard 2 PRO React TS examples components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// Data
import { MemberService } from "service/member/service";
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  ListItemText,
  Modal,
  OutlinedInput,
  Pagination,
  Radio,
  RadioGroup,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import MDInput from "components/MDInput";
import { info } from "../promotion/data/dummyPromotionData";
import DataTable from "examples/Tables/DataTable";
import { PaymentService } from "service/payment/service";
import { TapasTwoTone } from "@mui/icons-material";

const getTodayDate = (daysOffset = 0) => {
  const today = new Date();
  today.setDate(today.getDate() + daysOffset);
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

function PaymentLog(): JSX.Element {
  const limit = 10;
  const [tableData, setTableData] = useState<any[]>([]);

  const [sortType, setSortType] = useState("CD");
  const [productType, setProductType] = useState(["A"]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [startDate, setStartDate] = useState("2025-01-01");
  const [endDate, setEndDate] = useState(getTodayDate());
  const [search, setSearch] = useState("");

  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState<any>(null);

  const [modalCurrentPage, setModalCurrentPage] = useState<number>(1);
  const [modalTotalPages, setModalTotalPages] = useState<number>(1);
  const [modalStartDate, setModalStartDate] = useState(getTodayDate(-7));
  const [modalEndDate, setModalEndDate] = useState(getTodayDate());

  const list = async (page: number) => {
    try {
      const res = await PaymentService.log(page);

      console.log(res);
      setTableData(res.list);
      setTotalPages(Math.ceil(res.totalCount / limit));
    } catch (err) {
      console.log(err);
    }
  };

  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setCurrentPage(value);
  };
  useEffect(() => {
    list(currentPage);
  }, [currentPage]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox my={3}>
        {tableData && (
          <Card style={{ marginTop: "24px" }}>
            <div style={{ padding: "24px 16px" }}>
              <div style={{ overflowX: "auto" }}>
                <table style={{ minWidth: "1000px", width: "100%" }}>
                  <thead>
                    <tr
                      style={{
                        fontSize: "14px",
                        width: "100%",
                        textAlign: "center",
                        marginBottom: "16px",
                        fontFamily: "Pretendard",
                      }}
                    >
                      <th>결제 일시</th>
                      <th>구매 상품</th>
                      <th>결제 상태</th>
                      <th>결제수단</th>
                      <th>ip</th>
                      <th>구매자명</th>
                      <th>이메일</th>
                      <th>서버</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.map((el: any, idx) => (
                      <tr
                        key={idx}
                        style={{
                          fontSize: 12,
                          color: "#000000DE",
                          textAlign: "center",
                          fontFamily: "Pretendard",
                        }}
                      >
                        <td
                          style={{
                            borderBottom: "1px solid #0000001A",
                            padding: "16px 0",
                          }}
                        >
                          {el.create_time}
                        </td>
                        <td
                          style={{
                            borderBottom: "1px solid #0000001A",
                            padding: "16px 0",
                          }}
                        >
                          {el.good_name}
                        </td>
                        <td
                          style={{
                            borderBottom: "1px solid #0000001A",
                            padding: "16px 0",
                          }}
                        >
                          {el.status}
                          <br />
                          {el.description}
                        </td>
                        <td
                          style={{
                            borderBottom: "1px solid #0000001A",
                            padding: "16px 0",
                          }}
                        >
                          {el.method}
                        </td>
                        <td
                          style={{
                            borderBottom: "1px solid #0000001A",
                            padding: "16px 0",
                          }}
                        >
                          {el.ip}
                        </td>
                        <td
                          style={{
                            borderBottom: "1px solid #0000001A",
                            padding: "16px 0",
                          }}
                        >
                          {el.name}
                        </td>
                        <td
                          style={{
                            borderBottom: "1px solid #0000001A",
                            padding: "16px 0",
                          }}
                        >
                          {el.email}
                        </td>
                        <td
                          style={{
                            borderBottom: "1px solid #0000001A",
                            padding: "16px 0",
                          }}
                        >
                          {el.is_test === 1 ? "개발" : "운영"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div style={{ display: "flex", justifyContent: "center", marginTop: "24px" }}>
                <Pagination
                  count={totalPages}
                  page={currentPage}
                  onChange={handlePageChange}
                  color="secondary"
                  sx={{
                    "& .MuiPaginationItem-root": {
                      "&.Mui-selected": {
                        backgroundColor: "#1e9b6b",
                        color: "white",
                      },
                      "&.Mui-selected:hover": {
                        backgroundColor: "#1e9b6b",
                      },
                    },
                  }}
                />
              </div>
            </div>
          </Card>
        )}
      </MDBox>
    </DashboardLayout>
  );
}
export default PaymentLog;

const sortData = [
  { label: "최신순", value: "CD" },
  { label: "오래된순", value: "CA" },
];

const productData = [
  { value: "A", label: "전체" },
  { value: "얼리버드", label: "얼리버드(50%)" },
];
